import { mapGetters } from "vuex";
import { scrollToTop } from "@/views/checkout/utils";
import { validateZmHardware } from '@/plans/ZOOM_DEVICE/helper/validate';
import { isEqual } from 'lodash';
import { logger } from '@/utils/log';

export default {
  data() {
    return {
      mx_alertOpts: null,
      // Store the unsubscribe function for this instance
      unsubscribeDeviceAlert: null
    }
  },
  created() {
    // Create a unique event handler for this instance
    this.instanceDeviceAlertHandler = (opts) => {
      this.mx_alertOpts = opts;
      if (opts) {
        !this.isExpanded && (this.isExpanded = true);
        this.$nextTick(() => {
          if (this.$refs.mx_alert) {
            scrollToTop(this.$refs.mx_alert.$el);
          }
        });
      }
    };

    // Register event listener and store unsubscribe function
    this.unsubscribeDeviceAlert = this.$context.$on('device-license-match-alert', this.instanceDeviceAlertHandler);
  },
  computed: {
    ...mapGetters(['getSelectedPlansWithQuantityMap']),
  },
  beforeUnmount() {
    // Use the stored unsubscribe function to remove only this instance's listener
    if (this.unsubscribeDeviceAlert) {
      this.unsubscribeDeviceAlert();
    }
  },
  watch: {
    getSelectedPlansWithQuantityMap: {
      handler(val, oldVal) {
        if (!isEqual(val, oldVal)) {
          validateZmHardware({ emitMessage: false })
          .then(() => this.$context.$emit('device-license-match-alert', null))
          .catch((e) => logger.warn(e))
        }
      },
    },
  }
}
